import { useParams } from 'react-router-dom';
import type { EntityData } from '@ContractBuilder/types';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import { queryOptions, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import type { UseQueryRefetchFn, UseQueryStatus } from '../../@types/types';

import type { QueryFactory } from './factory.types';

const getUrl = (submissionId: string) => ['submissions', submissionId, 'renewals'].join('/');

export const fetchRenewals = async (submissionId: string): Promise<EntityData[]> => {
  const params = new URLSearchParams();
  const networkPayload = await getRequestAuthPayload({
    method: 'get',
    url: getUrl(submissionId),
    params,
  });

  const response = await axios(networkPayload);
  return response.data;
};

export const renewalQueries = {
  forSubmission: (submissionId: string) =>
    queryOptions({
      queryKey: ['renewals', submissionId] as const,
      queryFn: () => fetchRenewals(submissionId),
      staleTime: 0,
    }),
} satisfies QueryFactory;

interface RenewalsDataHook {
  data: EntityData[] | undefined;
  status: UseQueryStatus;
  isFetching: boolean;
  refetch: UseQueryRefetchFn<any, any>;
}

export const useRenewalsData = (): RenewalsDataHook => {
  const { id = '' } = useParams<{ id: string }>();
  const { data, status, isFetching, refetch } = useQuery(renewalQueries.forSubmission(id));
  return { data: data as EntityData[], status, isFetching, refetch };
};
